import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  imports: [NgClass],
})
export class LoadingSpinnerComponent {
  @Input() message?: string;
  @Input() fullHeight: boolean = true;
  @Input() fullPage: boolean = false;
  @Input() inline: boolean = false;
  @Input() textClass: string = 'text-primary';
}
